import styled from "styled-components";

export const Wraper = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  /* margin-bottom: 40px; */
  .ant-tabs {
    width: 100%;
  }
  .ant-tabs .ant-tabs-tab {
    color: #1d1d1d;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }
  .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: var(--sidebar-item-active);
  }
  .ant-tabs .ant-tabs-ink-bar {
    background-color: var(--sidebar-item-active);
  }
`;
